// Country codes in this file are ISO_3166-1 alpha-2 codes https://en.wikipedia.org/wiki/ISO_3166-1
// AU, GB, US, ...

// This more of an internal region definition
export const ANZ = ['AU', 'NZ']

// sourced from APAC / EMEA / etc entries of acronyms glossary
// https://blakeelearning.atlassian.net/wiki/spaces/MD/pages/471629826/Acronyms+Glossary

export const APAC = [
  'AS', // American Samoa
  'AQ', // Antarctica
  'AU', // Australia
  'BD', // Bangladesh
  'BT', // Bhutan
  'BV', // Bouvet Island
  'BN', // Brunei Darussalam
  'KH', // Cambodia
  'CN', // China
  'CX', // Christmas Island
  'CC', // Cocos (Keeling) Islands
  'CK', // Cook Islands
  'FJ', // Fiji
  'PF', // French Polynesia
  'TF', // French Southern Territories
  'GU', // Guam
  'HM', // Heard and McDonald Islands
  'HK', // Hong Kong
  'ID', // Indonesia
  'JP', // Japan
  'KI', // Kiribati
  'LA', // Lao People's Democratic Republic
  'MO', // Macao
  'MY', // Malaysia
  'MH', // Marshall Islands
  'FM', // Micronesia, Federated States of
  'MN', // Mongolia
  'MM', // Myanmar
  'NR', // Nauru
  'NP', // Nepal
  'NC', // New Caledonia
  'NZ', // New Zealand
  'NU', // Niue
  'NF', // Norfolk Island
  'MP', // Northern Mariana Islands
  'PW', // Palau
  'PG', // Papua New Guinea
  'PH', // Philippines
  'WS', // Samoa
  'SG', // Singapore
  'SB', // Solomon Islands
  'LK', // Sri Lanka
  'TW', // Taiwan
  'TH', // Thailand
  'TL', // Timor-Leste
  'TK', // Tokelau
  'TO', // Tonga
  'TV', // Tuvalu
  'VU', // Vanuatu
  'VN', // Viet Nam
  'WF', // Wallis and Futuna
]

export const EMEA = [
  'AF', // Afghanistan,
  'AX', // Aland Islands,
  'AL', // Albania,
  'DZ', // Algeria
  'AD', // Andorra
  'AO', // Angola
  'AM', // Armenia
  'AT', // Austria
  'AZ', // Azerbaijan
  'BH', // Bahrain
  'BY', // Belarus
  'BE', // Belgium
  'BJ', // Benin
  'BA', // Bosnia and Herzegowina
  'BW', // Botswana
  'IO', // British Indian Ocean Territory
  'BG', // Bulgaria
  'BF', // Burkina Faso
  'BI', // Burundi
  'CM', // Cameroon
  'CV', // Cabo Verde
  'CF', // Central African Republic
  'TD', // Chad
  'KM', // Comoros
  'CG', // Congo
  'CD', // “Congo, the Democratic Republic of the”
  'CI', // Cote d'Ivoire
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic aka Czechia
  'DK', // Denmark
  'DJ', // Djibouti
  'EG', // Egypt
  'GQ', // Equatorial Guinea
  'ER', // Eritrea
  'EE', // Estonia
  'ET', // Ethiopia
  'FK', // Falkland Islands (Malvinas)
  'FO', // Faroe Islands
  'FI', // Finland
  'FR', // France
  'GA', // Gabon
  'GM', // Gambia
  'GE', // Georgia
  'DE', // Germany
  'GH', // Ghana
  'GI', // Gibraltar
  'GR', // Greece
  'GL', // Greenland
  'GP', // Guadeloupe
  'GG', // Guernsey
  'GN', // Guinea
  'GW', // Guinea-Bissau
  'VA', // “Holy See, Vatican City State”
  'HU', // Hungary
  'IS', // Iceland
  'IR', // “Iran, Islamic Republic of”
  'IQ', // Iraq
  'IE', // Ireland
  'IM', // Isle of Man
  'IL', // Israel
  'IT', // Italy
  'JE', // Jersey
  'JO', // Jordan
  'KZ', // Kazakhstan
  'KE', // Kenya
  'KW', // Kuwait
  'KG', // Kyrgyzstan
  'LV', // Latvia
  'LB', // Lebanon
  'LS', // Lesotho
  'LR', // Liberia
  'LY', // Libya
  'LI', // Liechtenstein
  'LT', // Lithuania
  'LU', // Luxembourg
  'MK', // “Macedonia, The Former Yugoslav Republic Of”
  'MG', // Madagascar
  'MW', // Malawi
  'MV', // Maldives
  'ML', // Mali
  'MT', // Malta
  'MQ', // Martinique
  'MR', // Mauritania
  'MU', // Mauritius
  'YT', // Mayotte
  'MD', // “Moldova, Republic of”
  'MC', // Monaco
  'ME', // Montenegro
  'MA', // Morocco
  'MZ', // Mozambique
  'NA', // Namibia
  'NL', // Netherlands
  'BQ', // Netherlands Antilles	(aka Bonaire, Sint Eustatius and Saba)
  'NE', // Niger
  'NG', // Nigeria
  'NO', // Norway
  'OM', // Oman
  'PK', // Pakistan
  'PS', // “Palestine, State of”
  'PL', // Poland
  'PT', // Portugal
  'QA', // Qatar
  'RE', // Reunion
  'RO', // Romania
  'RW', // Rwanda
  'SH', // Saint Helena
  'LC', // Saint Lucia
  'SM', // San Marino
  'ST', // Sao Tome and Principe
  'SA', // Saudi Arabia
  'SN', // Senegal
  'RS', // Serbia
  'SC', // Seychelles
  'SL', // Sierra Leone
  'SK', // Slovakia
  'SI', // Slovenia
  'SO', // Somalia
  'ZA', // South Africa
  'SS', // South Sudan
  'ES', // Spain
  'SD', // Sudan
  'SJ', // Svalbard and Jan Mayen
  'SZ', // Eswatini
  'SE', // Sweden
  'CH', // Switzerland
  'SY', // Syrian Arab Republic
  'TJ', // Tajikistan
  'TZ', // “Tanzania, United Republic of”
  'TG', // Togo
  'TN', // Tunisia
  'TR', // Turkey
  'TM', // Turkmenistan
  'UG', // Uganda
  'UA', // Ukraine
  'AE', // United Arab Emirates
  'GB', // United Kingdom
  'UZ', // Uzbekistan
  'EH', // Western Sahara
  'YE', // Yemen
  'ZM', // Zambia
  'ZW', // Zimbabwe
]

export const AMER = [
  'AI', // Anguilla
  'AG', // Antigua and Barbuda
  'AR', // Argentina
  'AW', // Aruba
  'BS', // Bahamas
  'BB', // Barbados
  'BZ', // Belize
  'BM', // Bermuda
  'BO', // Bolivia
  'BR', // Brazil
  'CA', // Canada
  'KY', // Cayman Islands
  'CL', // Chile
  'CO', // Colombia
  'CR', // Costa Rica
  'CU', // Cuba
  'DM', // Dominica
  'DO', // Dominican Republic
  'EC', // Ecuador
  'SV', // El Salvador
  'FK', // Falkland Islands, Malvinas
  'GF', // French Guiana
  'GD', // Grenada
  'GT', // Guatemala
  'GY', // Guyana
  'HT', // Haiti
  'HN', // Honduras
  'JM', // Jamaica
  'MQ', // Martinique
  'MX', // Mexico
  'MS', // Montserrat
  'NI', // Nicaragua
  'PA', // Panama
  'PY', // Paraguay
  'PE', // Peru
  'PN', // Pitcairn
  'PR', // Puerto Rico
  'BL', // Saint Barthelemy
  'KN', // Saint Kitts and Nevis
  'PM', // Saint Pierre and Miquelon
  'VC', // Saint Vincent and the Grenadines
  'GS', // South Georgia and the South Sandwich Islands
  'SR', // Suriname
  'TT', // Trinidad and Tobago
  'TC', // Turks and Caicos Islands
  'US', // United States
  'UM', // United States Minor Outlying Islands
  'UY', // Uruguay
  'VE', // Venezuela
  'VG', // "Virgin Islands British"
  'VI', // "Virgin Islands U.S"
]
